import styled from 'styled-components';
import * as c from '../../styles/palette';

const SecondaryTabsSelector = `
  border-bottom: 1px solid ${c.gray};
  color: ${c.gray};
  * {
    text-align: center;
    background-color: transparent;
    font-size: 16px;
    padding: 12px;
  }
  .expanded {
    width: 240px;
  }
  .active {
    border: none;
    border-bottom: 2px solid ${c.orange};
    font-weight: 600;
    color: ${c.orange};
  }
`;

export const TabsNavigation = styled.div`
  width: 100%;

  // @media (max-width: 768px) {
  //   // overflow-x: scroll;
  // }
`;

export const TabsSelector = styled.div`
  display: flex;
  justify-content: start;
  gap: 8px;

  &.secondary {
    ${SecondaryTabsSelector}
       white-space: nowrap;
    overflow-x: auto;
}
  }
`;

export const TabSelector = styled.div`
  cursor: pointer;
  font-size: 14px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${c.lightGray};
  padding: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  :hover {
    opacity: 0.8;
  }

  &.loading-tab {
    pointer-events: none;
    cursor: not-allowed;
  }

  &.active {
    background-color: white;
    border: 1px solid ${c.lightGray};
    font-weight: 700;
    border-bottom: 2px solid ${c.orange};
  }
`;

export const TabsContent = styled.table`
  font-size: 14px;
  width: 100%;
  margin: 32px 0 0;
  border-collapse: collapse;
`;

export const TabsRow = styled.tr`
  &:nth-child(even) {
    background-color: ${c.lightSecondary};
  }
`;

export const TabsHead = styled.th`
  cursor: pointer;
  padding: 16px;
  transition: 0.2s ease;

  &.active {
    color: ${c.orange};
  }

  :hover {
    color: ${c.orange};
  }
`;

export const TabArrow = styled.img`
  margin: 0 0 2px 5px;
`;

export const TabsData = styled.td`
  cursor: pointer;
  text-align: center;
  padding: 16px;

  &.start {
    text-align: start;
  }
`;

export const TabDownload = styled.img`
  cursor: pointer;
  height: 16px;
  width: 16px;
`;

export const TabsContainer = styled.div`
  margin: 40px 0px;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const gridTemplate = `
  350px   /* Contexto */
  140px   /* EAN */
  180px   /* Data */
  250px   /* Erro */
  240px   /* Ações */
`;

export const TabHeader = styled.div`
  display: grid;
  grid-template-columns: ${gridTemplate};
  width: max-content;
  min-width: 100%;
  background-color: ${c.light};
  border-bottom: 1px solid ${c.graySecondary};
  font-weight: 700;
`;

export const TabBody = styled.div`
  display: grid;
  grid-template-columns: ${gridTemplate};
  width: max-content;
  min-width: 100%;
  border-bottom: 1px solid ${c.graySecondary};
  transition: 0.2s ease all;

  &:hover {
    background-color: ${c.light};
  }
`;
export const TabCell = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TabBadge = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 24px;
  max-height: 24px;
  border-radius: 8px;
  color: white;
  font-size: 12px !important;
  background-color: ${c.orange} !important;

  &.inactive {
    background-color: ${c.textGray} !important;
  }
`;
